function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React from 'react';
import { store } from '@applyboard/ab-common';
import { Button, Notice } from '@applyboard/crystal-ui';
import { Box } from '@applyboard/ui-components';
import { useEventTracker } from '@applyboard/ui-utils';
import useInitialProps from "../../../../hooks/useInitialProps";
import { useDocumentDiscrepancy } from "../../../../data/documentDiscrepancy";
import { applicationSetTabAction, applicationSetPreviewRequirementIdAction } from "../../../../store/actions/application";
import SidebarRow from "../SidebarRow/SidebarRow";
import { StudentRow, StudentContent } from "../Student";
import { TestRow, TestContent } from "../Test";
import { AgentRow, AgentContent } from "../Agent";
import SalesRepRow from "../SalesRepresentative";
import ThirdPartyRow from "../ThirdParty";
import Status from "../Status";
import { _StudentSection } from "../styles";
var SidebarStudentSection = function SidebarStudentSection(_ref) {
  var _Object$keys, _Object$keys2;
  var address = _ref.address,
    application = _ref.application,
    expandAll = _ref.expandAll,
    hasPermission = _ref.hasPermission,
    info = _ref.info,
    isRowLoading = _ref.isRowLoading,
    originalSalesRep = _ref.originalSalesRep,
    onActionClick = _ref.onActionClick,
    onActionClickNoSweetAlert = _ref.onActionClickNoSweetAlert,
    onReadyForVisa = _ref.onReadyForVisa,
    onReadyToSubmit = _ref.onReadyToSubmit,
    onSubmittedToSchool = _ref.onSubmittedToSchool,
    refetchTestScores = _ref.refetchTestScores,
    salesRep = _ref.salesRep,
    salesRepTitle = _ref.salesRepTitle,
    school = _ref.school,
    schools = _ref.schools,
    showGraduationCap = _ref.showGraduationCap,
    showLoginEmailValidation = _ref.showLoginEmailValidation,
    showOriginalRep = _ref.showOriginalRep,
    showPrimaryEmailValidation = _ref.showPrimaryEmailValidation,
    showReps = _ref.showReps,
    showWarningForResidenceUtil = _ref.showWarningForResidenceUtil,
    student_information_id = _ref.student_information_id,
    submission_through = _ref.submission_through,
    testScores = _ref.testScores,
    BackgroundSection = _ref.BackgroundSection,
    EducationSection = _ref.EducationSection,
    reloadAggregatedData = _ref.reloadAggregatedData,
    ProcessDeferralModal = _ref.ProcessDeferralModal,
    isMarkdownRendererEnabled = _ref.isMarkdownRendererEnabled;
  // differentiate between passport & ielts documents
  useInitialProps();
  var _useDocumentDiscrepan = useDocumentDiscrepancy({
      resourceId: application === null || application === void 0 ? void 0 : application.id,
      resourceType: 'applications',
      enabled: hasPermission('view_internal_notices')
    }),
    documentDiscrepancyMapping = _useDocumentDiscrepan.documentDiscrepancyMapping;
  var ieltsDiscrepancies = getDiscrepancyMappingByType({
    discrepancyType: 'ielts_discrepancy',
    documentDiscrepancyMapping: documentDiscrepancyMapping
  });
  var passportDiscrepancies = getDiscrepancyMappingByType({
    discrepancyType: 'passport_discrepancy',
    documentDiscrepancyMapping: documentDiscrepancyMapping
  });
  return /*#__PURE__*/React.createElement(_StudentSection, null, /*#__PURE__*/React.createElement(SidebarRow, {
    content: /*#__PURE__*/React.createElement(Status, {
      onSubmittedToSchool: onSubmittedToSchool,
      hasPermission: hasPermission,
      application: application,
      info: info,
      onActionClick: onActionClick,
      onActionClickNoSweetAlert: onActionClickNoSweetAlert,
      onReadyToSubmit: onReadyToSubmit,
      onReadyForVisa: onReadyForVisa,
      reloadAggregatedData: reloadAggregatedData,
      ProcessDeferralModal: ProcessDeferralModal,
      isMarkdownRendererEnabled: isMarkdownRendererEnabled
    }),
    key: "student-sidebar-status",
    loading: isRowLoading('status'),
    title: "Status"
  }), /*#__PURE__*/React.createElement(SidebarRow, {
    title: "Student",
    key: "student-sidebar-student",
    show: hasPermission('view_personal_information'),
    content: application && /*#__PURE__*/React.createElement(StudentRow, {
      application: application,
      info: info,
      hasPermission: hasPermission
    }),
    expandedContent: application && /*#__PURE__*/React.createElement(StudentContent, {
      info: info,
      applicationId: application === null || application === void 0 ? void 0 : application.id,
      showLoginEmailValidation: showLoginEmailValidation,
      showPrimaryEmailValidation: showPrimaryEmailValidation
    }),
    noticeComponent: (_Object$keys = Object.keys(passportDiscrepancies)) !== null && _Object$keys !== void 0 && _Object$keys.length ? /*#__PURE__*/React.createElement(DiscrepancyWarning, {
      application: application,
      discrepancies: passportDiscrepancies
    }) : null,
    expandAll: expandAll
  }), hasPermission('view_residential_address') && /*#__PURE__*/React.createElement(BackgroundSection, {
    address: address,
    info: {
      countryOfCitizenship: info.country_of_citizenship,
      countryOfCitizenshipVerifiedAt: info.country_of_citizenship_verified_at
    },
    showResidenceWarning: showWarningForResidenceUtil,
    expandAll: expandAll
  }), hasPermission('view_education_summary') && /*#__PURE__*/React.createElement(EducationSection, {
    info: {
      studiedLevel: info.studied_level,
      educationCountry: info.education_country,
      gradingScheme: info.grading_scheme,
      grade: info.grade,
      gradeScale: info.grade_scale
    },
    showGraduationCap: showGraduationCap,
    schools: schools.map(function (school) {
      return {
        schoolName: school.school_name,
        level: school.level,
        language: school.language,
        hasGraduated: school.has_graduated,
        hasGraduatedEnabled: school.has_graduated_enabled,
        degreeAwarded: school.degree_awarded,
        degreeName: school.degree_name,
        dateGraduated: school.date_graduated,
        dateDegreeAwarded: school.date_degree_awarded,
        startDate: school.start_date,
        endDate: school.end_date,
        address: school.address
      };
    }),
    expandAll: expandAll
  }), /*#__PURE__*/React.createElement(SidebarRow, {
    title: "English Test",
    key: "student-sidebar-english-test",
    content: application && /*#__PURE__*/React.createElement(TestRow, {
      testScores: testScores,
      displayModalButton: hasPermission('verify_ielts') && hasPermission('view_personal_information'),
      student_information_id: student_information_id,
      refetchTestScores: refetchTestScores
    }),
    show: hasPermission('view_test_scores'),
    expandedContent: /*#__PURE__*/React.createElement(TestContent, {
      testScores: testScores
    }),
    noticeComponent: (_Object$keys2 = Object.keys(ieltsDiscrepancies)) !== null && _Object$keys2 !== void 0 && _Object$keys2.length ? /*#__PURE__*/React.createElement(DiscrepancyWarning, {
      application: application,
      discrepancies: ieltsDiscrepancies
    }) : null,
    expandAll: expandAll
  }), /*#__PURE__*/React.createElement(SidebarRow, {
    show: hasPermission('view_representative_and_submission_method'),
    title: "Recruitment Partner",
    key: "student-sidebar-english-agent",
    content: application && /*#__PURE__*/React.createElement(AgentRow, {
      application: application,
      hasPermission: hasPermission
    }),
    expandedContent: application && /*#__PURE__*/React.createElement(AgentContent, {
      application: application
    }),
    expandAll: expandAll
  }), /*#__PURE__*/React.createElement(SidebarRow, {
    show: showReps && hasPermission('view_representative_and_submission_method'),
    title: salesRepTitle,
    key: "student-sidebar-english-sales_rep",
    content: /*#__PURE__*/React.createElement(SalesRepRow, {
      salesRep: salesRep
    }),
    expandAll: expandAll
  }), /*#__PURE__*/React.createElement(SidebarRow, {
    show: showReps && showOriginalRep && hasPermission('view_representative_and_submission_method'),
    title: "Original Representative",
    key: "student-sidebar-english-original-sales_rep",
    content: /*#__PURE__*/React.createElement(SalesRepRow, {
      salesRep: originalSalesRep
    }),
    expandAll: expandAll
  }), submission_through && hasPermission('view_representative_and_submission_method') && /*#__PURE__*/React.createElement(SidebarRow, {
    title: "Submission Method",
    content: /*#__PURE__*/React.createElement(ThirdPartyRow, {
      submission_through: school === null || school === void 0 ? void 0 : school.submission_through,
      submission_path_note: school === null || school === void 0 ? void 0 : school.submission_path_note
    })
  }));
};
function getDiscrepancyMappingByType(_ref2) {
  var _Object$keys3;
  var discrepancyType = _ref2.discrepancyType,
    documentDiscrepancyMapping = _ref2.documentDiscrepancyMapping;
  if (!((_Object$keys3 = Object.keys(documentDiscrepancyMapping)) !== null && _Object$keys3 !== void 0 && _Object$keys3.length)) return {};
  return Object.keys(documentDiscrepancyMapping).filter(function (attachmentId) {
    return documentDiscrepancyMapping[attachmentId].type === discrepancyType && documentDiscrepancyMapping[attachmentId].discrepancies.length !== 0;
  }).reduce(function (mapping, attachmentId) {
    mapping[attachmentId] = documentDiscrepancyMapping[attachmentId];
    return mapping;
  }, {});
}
function DiscrepancyWarning(_ref3) {
  var application = _ref3.application,
    discrepancies = _ref3.discrepancies;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  function getEventType(discrepancyType) {
    switch (discrepancyType) {
      case 'ielts_discrepancy':
        return 'IELTS';
      case 'passport_discrepancy':
        return 'Passport';
      default:
        return '';
    }
  }
  return /*#__PURE__*/React.createElement(Notice, {
    intent: "warning",
    width: "fill"
  }, /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement("span", null, "Student data may have unresolved conflicts."), /*#__PURE__*/React.createElement(Button, {
    intent: "warning",
    variant: "transparent",
    width: "hug",
    onClick: function onClick() {
      var _application$agent;
      var _Object$entries$ = _slicedToArray(Object.entries(discrepancies)[0], 2),
        firstDiscrepancyAttachmentId = _Object$entries$[0],
        firstDiscrepancy = _Object$entries$[1];
      store.dispatch(applicationSetTabAction('Preview Requirements'));
      store.dispatch(applicationSetPreviewRequirementIdAction(firstDiscrepancy.application_requirement_id, firstDiscrepancyAttachmentId));
      trackEvent({
        event: "Single Application - ".concat(getEventType(firstDiscrepancy.type), " Discrepancies - Clicked \u201CReview\u201D Discrepancies"),
        data: {
          applicationId: application === null || application === void 0 ? void 0 : application.id,
          applicantRpId: application === null || application === void 0 ? void 0 : (_application$agent = application.agent) === null || _application$agent === void 0 ? void 0 : _application$agent.id
        }
      });
    }
  }, "Review")));
}
export default /*#__PURE__*/React.memo(SidebarStudentSection);